/**
 *  Search navigation
 *  @author Livescore <live@score-stats.com>
 *  @copyright 2019 livescore
 */
import { Pipe, PipeTransform } from '@angular/core';
import { FavoriteService } from 'src/app/services/favorite.service';
import SPORT_CONFIG from 'src/app/config/sport.config';

@Pipe({
    name: 'navSearch',
})
export class NaviSearchPipe implements PipeTransform {
    public constructor(private favorite: FavoriteService) {}

    public transform(
        value: any,
        type: string,
        text: any,
        sportId?: number,
        sportName?: string,
        limit?: number,
    ): any {
        let fce;
        let isObject = false;
        if (Array.isArray(value) && value.length > 0 && 'value' in value[0]) {
            isObject = true;
        }

        if (type === 'fulltext') {
            if (typeof text === 'undefined' || text.length < 3) {
                if (limit !== undefined && limit !== null && value) {
                    return value.slice(0, limit);
                }

                return value;
            }
            text = text.toLowerCase();
            const globalRegex = RegExp(text, 'g');
            fce = (v: any): boolean => {
                const t = v.name.toLowerCase();

                return !!(t.match(globalRegex) ?? false);
            };
        } else if (type === 'alpha') {
            if (typeof text === 'undefined') {
                return value;
            }
            fce = (v: any): boolean => {
                let t: string = '';
                let star = true;
                if (isObject) {
                    const [first] = v.value;
                    v = first;
                }

                if (
                    'sub_tournament_name' in v &&
                    sportName !== undefined &&
                    SPORT_CONFIG.isSet(sportName as string) &&
                    v.sub_tournament_name !== null
                ) {
                    t = v.sub_tournament_name.toLowerCase().charAt(0);
                } else if (
                    'category_name' in v &&
                    v.category_name !== null
                ) {
                    t = v.category_name.toLowerCase().charAt(0);
                } else if (v.name && v.name !== null) {
                    t = v.name.toLowerCase().charAt(0);
                }

                if (
                    text.star !== undefined &&
                    text.star === true
                ) {
                    star = this.favorite.existsTournament(
                        sportId as number,
                        v.tournament_id,
                    );
                }

                return (
                    (text.alpha.length === 0 ||
                        text.alpha.indexOf(t) !== -1) &&
                    star
                );
            };
        }

        return value.filter(fce);
    }
}
